import {
  Box,
  Button,
  Center,
  HStack,
  Heading,
  Input,
  Text,
  useToast,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import usePathNavigate from '../lib/hook/usePathNavigate';
import { ChangeEvent, useState } from 'react';
import { onRegexValidationPhone } from '../lib/util/regular';

function ProgressCheck() {
  const { pathNavigate, backNavigate } = usePathNavigate();
  const toast = useToast();

  const [regNumber, setRegNumber] = useState<string>('');
  const [regName, setRegName] = useState<string>('');
  const [phoneNumber, setPhoneNumber] = useState<string>('');

  const onChangeRegNumber = (e: ChangeEvent<HTMLInputElement>) => {
    setRegNumber(e.target.value);
  };
  const onChangeRegName = (e: ChangeEvent<HTMLInputElement>) => {
    setRegName(e.target.value);
  };
  const onChangePhoneNumber = (e: ChangeEvent<HTMLInputElement>) => {
    const phoneNum = onRegexValidationPhone(e.target.value);
    setPhoneNumber(phoneNum);
  };

  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const onSubmitCheck = async () => {
    if (isSubmitLoading) {
      toast({
        description: '신청을 처리 중입니다',
        status: 'warning',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
      return;
    }
    setIsSubmitLoading(true);
    try {
      // 서버로부터 토큰을 받는다
      pathNavigate('/progressresult', {
        state: {
          token: '',
          reg_number: regNumber,
          reg_name: regName,
          phone_number: phoneNumber,
        },
      });
    } catch (err: any) {
      toast({
        title: '오류',
        description: err.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <Box>
      <HStack>
        <Center
          w="100%"
          h="60px"
          bgColor={'white'}
          fontSize="20px"
          borderBottomWidth={'1px'}
          fontWeight={'semibold'}>
          진행조회
        </Center>
        <CloseIcon
          position={'absolute'}
          right={'16px'}
          boxSize={'24px'}
          onClick={() => {
            backNavigate();
          }}
        />
      </HStack>
      <Box alignItems={'flex-start'} mt={'36px'} mb={'0px'} px={'20px'}>
        <Heading fontSize={'16px'} fontWeight="semibold">
          접수번호 *
        </Heading>
        <Text
          fontSize={'12px'}
          fontWeight="semibold"
          color={'#128cfe'}
          mt={'16px'}>
          접수번호를 모르실 경우 채팅상담으로 문의해 주세요.
        </Text>
        <Input
          w="100%"
          h={'54px'}
          mt={'8px'}
          fontSize={'1rem'}
          fontWeight="semibold"
          focusBorderColor={'mint.500'}
          borderColor={'#eee'}
          borderRadius="base"
          placeholder="접수번호를 입력하세요"
          _placeholder={{ color: '#bdbdbd', fontSize: '0.875rem' }}
          value={regNumber}
          onChange={onChangeRegNumber}
        />
        <Heading fontSize={'16px'} fontWeight="semibold" mt={'24px'}>
          접수자명 *
        </Heading>
        <Input
          w="100%"
          h={'54px'}
          mt={'16px'}
          fontSize={'1rem'}
          fontWeight="semibold"
          focusBorderColor={'mint.500'}
          borderColor={'#eee'}
          borderRadius="base"
          placeholder="반드시 접수시 이름을 입력하세요"
          _placeholder={{ color: '#bdbdbd', fontSize: '0.875rem' }}
          value={regName}
          onChange={onChangeRegName}
        />
        <Heading fontSize={'16px'} fontWeight="semibold" mt={'24px'}>
          전화번호 *
        </Heading>
        <Input
          w="100%"
          h={'54px'}
          mt={'16px'}
          fontSize={'1rem'}
          fontWeight="semibold"
          focusBorderColor={'mint.500'}
          borderColor={'#eee'}
          borderRadius="base"
          placeholder="010-1234-5678"
          _placeholder={{ color: '#bdbdbd', fontSize: '0.875rem' }}
          value={phoneNumber}
          onChange={onChangePhoneNumber}
        />
      </Box>
      <Box w={'full'} px="30px">
        <Button
          colorScheme={'black_button'}
          w="100%"
          h={'50px'}
          mt={'36px'}
          mb={'36px'}
          borderRadius={'base'}
          fontSize={'18px'}
          fontWeight="semibold"
          isLoading={isSubmitLoading}
          // isDisabled={regName === '' || regNumber === '' || phoneNumber === ''}
          onClick={onSubmitCheck}>
          진행현황 조회
        </Button>
      </Box>
    </Box>
  );
}

export default ProgressCheck;
